export default "__VITE_ASSET__5cd907db__"